export default "__VITE_ASSET__CkldiH1G__"